<div class="common-container">
  <p class="common-info">Manage AI Personas for your workspace.</p>
  @if (personasWithMetadataIsLoading$ | async) {
    <mat-progress-spinner [diameter]="40" mode="indeterminate"></mat-progress-spinner>
  }
</div>

@if (personasWithMetadata$ | async; as personas) {
  <div class="document-content">
    <h3 class="section-title">
      Workspace Personas ({{ personas?.length ?? 0 }})
      <button
        [disabled]="isDisabledEdit$ | async"
        *appRequiredRoles="[{ role: 'admin', status: ['DRAFTING', 'IN_REVIEW'] }]"
        mat-icon-button
        [matMenuTriggerFor]="personaMenu">
        <mat-icon>menu</mat-icon>
      </button>
      <mat-menu #personaMenu="matMenu">
        <button (click)="updateUsedPersonas()" mat-menu-item>
          <mat-icon>list_alt_add</mat-icon>
          <span>Update used personas</span>
        </button>
      </mat-menu>
    </h3>

    @if (personas && personas.length > 0) {
      <mat-accordion multi>
        @for (persona of personas; track persona.persona_id) {
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                @if (persona.type === 'viewer') {
                  <mat-icon class="persona-type-icon">visibility</mat-icon>
                }
                @if (persona.type === 'editor') {
                  <mat-icon class="persona-type-icon">edit</mat-icon>
                }
                <span class="persona-title"> {{ persona.name }} </span>
              </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="persona-details-container">
              <h2 class="section-heading">Type:</h2>
              <p>{{ persona.type | titlecase }}</p>
              <mat-divider class="section-divider"></mat-divider>

              <h2 class="section-heading">Description/Summary:</h2>

              <markdown
                [data]="
                  persona.description ||
                  persona.current_prompt ||
                  persona.summary ||
                  'No detailed description available.'
                "></markdown>
            </div>
          </mat-expansion-panel>
        }
      </mat-accordion>
    } @else {
      <p class="text-muted">No personas found for this workspace.</p>
    }
  </div>
}
@if (personasWithMetadataIsError$ | async) {
  <app-common-error-loading></app-common-error-loading>
}
